// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__33CnJ","colMaxWidth":"Table_colMaxWidth__2bC2j"};